import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const products = [
{
  slug: "sensor-network",
  title: "4G Eco9",
  image: "/assets/images/P3.png",
  specs: [
    { key: "Connectivity", value: "BLE Mesh" },
    { key: "Battery Backup", value: "2 Years" },
    { key: "Temperature Range", value: "-40°C to 85°C" },
    { key: "Humidity Range", value: "0% - 100% RH" },
    { key: "Accuracy", value: "±0.3°C" },
    { key: "Cloud Integration", value: "Supported" },
    { key: "Mounting", value: "Wall Mount" }
  ]
},
{
slug:"smart-track",
title:"Smart Track",
image:"/assets/images/P4.png",
  specs:[
  {key:"Connectivity",value:"4G LTE"},
  {key:"Battery Backup",value:"24 Hours"},
  {key:"Temperature Sensor",value:"Supported"},
  {key:"Humidity Sensor",value:"Supported"},
  {key:"Door Sensor",value:"Supported"},
  {key:"Cloud Integration",value:"Supported"},
  {key:"Alerts",value:"Real-time"}
  ]
},
{
slug:"ble-network",
title:"BLE Container Lock",
image:"/assets/images/P5.png",
specs:[
  {key:"Connectivity",value:"BLE Mesh"},
  {key:"Nodes Supported",value:"1000+"},
  {key:"Range",value:"100m Indoor"},
  {key:"Gateway Support",value:"Yes"},
  {key:"Latency",value:"Low"},
  {key:"Cloud Integration",value:"Supported"},
  {key:"Protocol",value:"MQTT"}
  ]
},

{
  slug: "ble-id-card",
  title: "BLE Smart ID Card",
  image: "/assets/images/BLE.png",
  specs: [
    { key: "Connectivity", value: "Bluetooth Low Energy (BLE) 5.0" },
    { key: "Communication Range", value: "Up to 50m (Open Area)" },
    { key: "Battery Life", value: "Up to 2 Years" },
    { key: "Battery Type", value: "Replaceable CR2032 Coin Cell" },
    { key: "Operating Temperature", value: "-20°C to 60°C" },
    { key: "Location Tracking", value: "Real-Time Indoor Positioning" },
    { key: "Access Control", value: "Contactless Authentication" },
    { key: "Applications", value: "Employee ID, Attendance & Visitor Management" }
  ]
},
{
  slug: "3-phase-ac-detection",
  title: "Wireless 3 Phase Ac Detection",
  image: "/assets/images/Modum1.png",
  specs: [
    { key: "Connectivity", value: "Bluetooth BLE 5.1" },
    { key: "Frequency Detection", value: "45Hz to 55Hz" },
    { key: "Supply Voltage", value: "1.8V to 3.6V" },
    { key: "Sleep Current", value: "7µA (Battery life ~2 years)" },
    { key: "Compatibility", value: "Configurable with SiWi 4G IOT & Teltonika GPS Trackers" },
    { key: "Dimensions", value: "107.81mm × 77.93mm × 39.62mm" },
    { key: "Weight", value: "123.45g" },
    { key: "Mounting", value: "Key hole mounting - Easy to carry & install" }
  ]
},
{
  slug: "E-rutu-tracker",
  title: "E-Rutu Tracker",
  image: "/assets/images/P6.png",
  specs: [
    { key: "Connectivity", value: "4G with 2G support" },
    { key: "BLE Support", value: "Up to 4 SiWi SWRT RHT + Door sensors" },
    { key: "BLE Monitoring", value: "Genset ON/OFF for Reefer & Warehouse" },
    { key: "Configuration", value: "BLE mobile app based configurable" },
    { key: "Offline Storage", value: "Up to 90,000 data points" },
    { key: "Operating Voltage", value: "8 VDC to 100 VDC" },
    { key: "Battery Backup", value: "330mAh to 10,000mAh (Default 300mAh)" },
    { key: "Protocol Support", value: "TCP socket and JSON over MQTT" }
  ]
},
{
  slug: "ble-rht-sensor",
  title: "BLE Wireless Temperature & Humidity (SWRT)",
  image: "/assets/images/Device002.png",
  specs: [
    { key: "Connectivity", value: "Bluetooth BLE 5.1" },
    { key: "Temperature Range", value: "-40°C to +80°C" },
    { key: "Humidity Range", value: "0% to 99.99%" },
    { key: "Transmission Distance", value: "~220 Meters (Line of Sight)" },
    { key: "Transmit Power", value: "7dBm (Configurable)" },
    { key: "Digital Input", value: "1 (Door switch support)" },
    { key: "Supply Voltage", value: "1.8V to 3.6V" },
    { key: "Sleep Current", value: "7µA (Battery life ~2 years)" },
    { key: "Dimensions", value: "56.18mm × 33.87mm × 18.91mm" },
    { key: "Weight", value: "25.15g" }
  ]
},

{
  slug: "e-vahan-tracker",
  title: "E-Vahan Tracker",
  image: "/assets/images/P6.png",
  specs: [
    { key: "Connectivity", value: "4G" },
    { key: "BLE Support", value: "BLE mobile app based configurable" },
    { key: "Vehicle Control", value: "Relay-less (MOSFET based) ON/OFF" },
    { key: "Keyless Operation", value: "BLE based app ON/OFF (Optional)" },
    { key: "Battery Management", value: "UART based BMS Monitoring" },
    { key: "Remote Control", value: "Battery enable/disable with auto locking" },
    { key: "Safety Feature", value: "Dragging auto WheelJam (Optional)" },
    { key: "Operating Voltage", value: "8 VDC to 100 VDC" },
    { key: "Battery Backup", value: "330mAh to 10,000mAh (Default 300mAh)" },
    { key: "Offline Storage", value: "Up to 90,000 data points" },
    { key: "Protocol Support", value: "TCP socket and JSON over MQTT" },
    { key: "Firmware Update", value: "FOTA (Firmware Over-The-Air)" }
  ]
},
{
  slug: "ble-asset-finder",
  title: "BLE Asset Finder",
  image: "/assets/images/Sensor_Case.png",
  specs: [
    { key: "Connectivity", value: "BLE 5.0+" },
    { key: "Real-Time Location", value: "Yes" },
    { key: "Built-in Buzzer", value: "Yes (Audible Alerts)" },
    { key: "Control", value: "App-Based Location Tracking" },
    { key: "Power Consumption", value: "Ultra Low Power" },
    { key: "Battery Life", value: "Year+ Battery Life" }
  ]
},

{
  slug: "ev-battery-finder",
  title: "EV Battery Finder",
  image: "/assets/images/Battery_EV.png",
  specs: [
    { key: "Technology", value: "Bluetooth Battery Finder" },
    { key: "Battery Management", value: "Battery Inventory Management" },
    { key: "Security Feature", value: "Smart BMS Lock" },
    { key: "Auto Lock", value: "Auto Battery Lock (Walk Away)" },
    { key: "Compatibility", value: "Compatible with EV 2-Wheelers" },
    { key: "Anti-Theft", value: "Yes" },
    { key: "Tracking", value: "Smart Battery Tracking" }
  ]
},
{
  slug: "ultra-long-range-ble-sensor",
  title: "Wireless LR RHT Sensor",
  image: "/assets/images/Modum.png",
  specs: [
    { key: "Connectivity", value: "Bluetooth LE 5.3" },
    { key: "Battery Backup", value: "Rechargeable - Up to 8 months" },
    { key: "Temperature Range", value: "-40°C to +70°C" },
    { key: "Temperature Accuracy", value: "±0.2°C" },
    { key: "RH Accuracy", value: "±1.8% RH" },
    { key: "Antenna", value: "Strong Antenna" },
    { key: "Range (Open)", value: "Up to 1200 meters" },
    { key: "Compatibility", value: "Teltonika GPS Tracker Devices" }
  ]
}



];

const ProductDetail = () => {

const { slug } = useParams();

const product = products.find(p => p.slug === slug);

// Scroll to top whenever the product (slug) changes, e.g. when clicking
// a card in "Other Products" while already on a product detail page.
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, [slug]);

if(!product){
return <div className="p-20 text-center">Product Not Found</div>;
}

const otherProducts = products.filter(p => p.slug !== slug);

return (

<div className="bg-white">

{/* HERO BANNER - flat, no curve, light gradient background */}

<div className="relative bg-gradient-to-r from-gray-500 via-gray-100 to-gray-500 text-gray-600 overflow-hidden">

<div className="max-w-7xl mx-auto text-center px-6">

<div className="py-28 md:py-36 min-h-[480px] flex flex-col items-center justify-center">

<h1 className="text-4xl font-bold mb-4">
Our Smart IoT Products
</h1>

<p className="text-gray-600 max-w-2xl mx-auto">
Reliable and scalable IoT devices designed for industrial automation,
fleet tracking and smart monitoring.
</p>

</div>

</div>

</div>


{/* PRODUCT DETAIL SECTION */}

<div className="max-w-7xl mx-auto py-16 px-6 grid md:grid-cols-2 gap-16 items-center">

{/* IMAGE */}

<div className="flex justify-center items-center h-[420px] overflow-visible">
<img
src={product.image}
alt={product.title}
className="max-h-full max-w-full object-contain scale-150"
/>
</div>

{/* SPEC TABLE */}

<div>

<h1 className="text-3xl font-bold text-gray-900 mb-6">
{product.title}
</h1>

<div className="border rounded-xl overflow-hidden">

<table className="w-full text-left">

<tbody>

{product.specs.map((spec,index)=>(
<tr key={index} className="border-b last:border-none">

<td className="py-3 px-4 font-semibold bg-gray-50 w-1/2">
{spec.key}
</td>

<td className="py-3 px-4 text-gray-700">
{spec.value}
</td>

</tr>
))}

</tbody>

</table>

</div>

</div>

</div>


{/* OTHER PRODUCTS */}

<div className="max-w-7xl mx-auto py-16 px-6">

<h2 className="text-2xl font-bold mb-10">
Other Products
</h2>

<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

{otherProducts.map(item=>(
<Link
key={item.slug}
to={`/products/${item.slug}`}
onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
className="bg-white border rounded-xl overflow-hidden shadow hover:shadow-lg transition"
>

<div className="w-full h-80 flex items-center justify-center overflow-visible p-6">
<img
src={item.image}
alt={item.title}
className="max-h-full max-w-full object-contain scale-150"
/>
</div>

<div className="p-5 text-center">

<h3 className="text-base font-semibold text-gray-800">
{item.title}
</h3>

</div>

</Link>
))}

</div>

</div>

</div>

);

};

export default ProductDetail;